import { Key } from "react"
import BaseDocumentElement from "../../../../components/elements/BaseDocumentElement"
import { DocumentDataType } from "../../../../components/types"
import { BillGet } from "../../../../data/Types"
import { BillRow } from "../BillRow"
import { useNavigate } from "react-router-dom"

type BillTemplateBillsAndFilesType = {
    bills: BillGet[]
    data: {
        additional_s3Documents: DocumentDataType[]
    }
    handleDownload: (item: { s3Key: string; filename: string }) => void
    handleChangePreviewElement: (e: string) => void
}

export default function BillTemplateBillsAndFiles(props: BillTemplateBillsAndFilesType) {
    const navigate = useNavigate()

    return (
        <div className="mt-4 w-full h-fit md:max-h-[16vh] rounded-default shadow-lg bg-white p-4 flex flex-col md:flex-row gap-4 md:gap-0">
            <div className="flex flex-col w-full">
                <p className="w-full border-b pb-2 font-medium">Zugeordnete Rechnungen</p>
                <div className="overflow-y-scroll">
                    {!props.bills || props.bills.length === 0 ? (
                        <p className="text-center uppercase text-sm text-gray-300 font-medium pt-1">Keine Rechnungen zugeordnet</p>
                    ) : (
                        props.bills?.map((item: BillGet, index: Key) => (
                            <BillRow key={index} item={item} navigate={() => navigate("/buchhaltung/rechnung/" + item._id)} />
                        ))
                    )}
                </div>
            </div>
            <div className="flex flex-col w-full">
                <p className="w-full border-b pb-2 font-medium">Zugeordnete Dateien</p>
                <div className="overflow-y-scroll">
                    {!props.data.additional_s3Documents || props.data.additional_s3Documents.length === 0 ? (
                        <p className="text-center uppercase text-sm text-gray-300 font-medium pt-1">Keine Dokumente hochgeladen</p>
                    ) : (
                        props.data?.additional_s3Documents.map((item: DocumentDataType, index: Key) => (
                            <BaseDocumentElement
                                key={index}
                                title={item.title}
                                timestamp={item.timestamp}
                                showPreviewFunc={() => props.handleChangePreviewElement("")}
                                downloadFunc={() => props.handleDownload({ s3Key: item.s3Key, filename: item.title })}
                            />
                        ))
                    )}
                </div>
            </div>
        </div>
    )
}
